export const POST_FEEDBACK_REQUEST = "POST_FEEDBACK_REQUEST"
export const POST_FEEDBACK_SUCCESS = "POST_FEEDBACK_SUCCESS"
export const POST_FEEDBACK_FALUIRE = "POST_FEEDBACK_FALUIRE"
export const TOGGLE_MODAL = "TOGGLE_MODAL"

export const FEEDBACK_PAGE_REQUEST = "FEEDBACK_PAGE_REQUEST"
export const FEEDBACK_PAGE_SUCCESS = "FEEDBACK_PAGE_SUCCESS"
export const FEEDBACK_PAGE_FALUIRE = "FEEDBACK_PAGE_FALUIRE"
